import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController, PopoverController, ToastController } from '@ionic/angular';
import { FromAddressComponent } from 'src/app/components/Coach/address/form-address/from-address.component';
import { Address } from 'src/app/models/address';
import { AddressService } from 'src/app/services/address.service';

@Component({
  selector: 'app-adress-popover',
  templateUrl: './adress-popover.component.html',
  styleUrls: ['./adress-popover.component.scss'],
})
export class AdressPopoverComponent  implements OnInit {

  @Input() address : Address
  constructor(
    private readonly ModalCtrl : ModalController,
    private readonly AlertCtrl : AlertController,
    private readonly addressService : AddressService,
    private readonly toastCtrl : ToastController,
    private readonly popoverCtrl : PopoverController,
  ) { }

  ngOnInit() {}

  async editAddress(){
    let modal = await this.ModalCtrl.create({
      component : FromAddressComponent,
      componentProps : {
        address : this.address,
        returnMode : true
      }
    });


    modal.present();

    const { data, role } = await modal.onDidDismiss();

    if(data){
      this.popoverCtrl.dismiss(data,role);
    }else{
      this.popoverCtrl.dismiss( null, "cancel" );
    }

  }

  async deleteAddress(){
    const alert = await this.AlertCtrl.create({
      header: 'Confirmation',
      message: `Voulez-vous vraiment supprimer l'adresse ${this.address.name} ?`,
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'secondary',
        }, {
          text: 'Supprimer',
          handler: () => {
            this.popoverCtrl.dismiss(null, "delete");
          }
        }
      ]
    });

    await alert.present();
  }

  private async showToast(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 2000,
      buttons: [{ text: 'Ok', role: 'cancel' }]
    });
    await toast.present();
  }

}
